import { Switch } from 'AppReact';
import mainContainers from './mainContainers';

const switcher = ({ selectedTabId }) => {
  return mainContainers[selectedTabId]
}

export default Switch(switcher)
